// Variables
let args = {};
let taxonomy = $(".see-all__settings-box").data("taxonomy");
let timer = null;
let value = "";
let sort = "";
args.sort = "ASC";
args.game = "empty";

// Sorting event listener
$("#sort").change(function() {
  args.sort = $(this).val();
  sort = $(this).val();
  if ($("#filter").val()) {
    filterItems();
  } else {
    getItems();
  }
});

// Filtering event listener
$("#filter").change(function() {
  args.game = $(this).val();
  args.name = value;
  if (sort) {
    args.sort = sort;
  } else {
    args.sort = "ASC";
  }
  args.offset = 0;
  filterItems();
});

// Searching event listener
$("#search").on("keyup", function() {
  let search = $.trim(
    $(this)
      .val()
      .toLowerCase()
  );
  value = search;
  args.taxonomy = taxonomy;
  args.name = search;
  args.offset = 0;
  if ($("#filter").length) {
    args.game = $("#filter").val();
  } else {
    args.game = "empty";
  }
  if (value.length) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      filterItems();
    }, 1000);
  } else {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      filterItems();
    }, 1000);
  }
});

// AJAX request to get initial state of see-all page
function getItems() {
  $.ajax({
    type: "POST",
    url: themeVars.adminUrl,
    data: {
      action: "get_sorted_items",
      args: args,
    },
    beforeSend: function() {
      $(".see-all__container").empty();
    },
    success: function(result) {
      $(".see-all__container").html(result);
    },
  });
}

// AJAX request to get mutation state of see-all page
function filterItems() {
  $.ajax({
    type: "POST",
    url: themeVars.adminUrl,
    data: {
      action: "filter_items",
      args: args,
    },
    beforeSend: function() {
      $(".see-all__container").empty();
    },
    success: function(result) {
      $(".see-all__container").html(result);
    },
  });
}

// Event listener for showing initial state of page
$(document).ready(function() {
  args.taxonomy = taxonomy;
  getItems();
});

// Event emitters for ajax pagination
$(document).on("click", ".page-numbers", function() {
  controllersClick($(this));
});

$(document).on("click", ".page-controls", function() {
  controllersClick($(this));
});

// Prevent Default for search
$("#search").keypress(function(e) {
  if (e.keyCode == "13") {
    e.preventDefault();
  }
});

// Function to control pagination
function controllersClick(item) {
  let page = item.data("page");
  args.offset = page * 36;
  filterItems();
}



// WEBPACK FOOTER //
// ./scripts/layouts/see-all-page.js